/**
 * Get the current date, either real or simulated for development
 * @returns {Date} Current or simulated date
 */
export function getCurrentDate() {
  // In development or staging, check for simulated date
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
    const simulatedDate = localStorage.getItem('devtools-simulated-date');
    if (simulatedDate) {
      return new Date(simulatedDate);
    }
  }

  // Return real current date
  return new Date();
}

/**
 * Check if we're currently time traveling (simulating a date)
 * @returns {boolean} True if simulating a date
 */
export function isTimeTravel() {
  const isSupportedEnv = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging';
  const hasSimulatedDate = !!localStorage.getItem('devtools-simulated-date');

  return isSupportedEnv && hasSimulatedDate;
}
